import { Outlet } from "react-router-dom";
import { getWlcServiceLocationBase } from '../../common/api/data';
//import { compareAsc, format } from 'date-fns'
import { useState, useEffect } from "react";

//import { authenticate } from '../../common/api/auth';

import { SeasonsTable } from './seasonlist_components/seasonstable';

//import '../../common/css/App.css';
//import '../../common/css/newstuff.css';
//import './wlc.css';

const SeasonList = () => {
	const [seasonList, setSeasonList] = useState([]);

	useEffect( () => {
		pageLoad();
	}, []);

	const pageLoad = async () => {
		const token = 'abc';//await authenticate();
		loadSeasonListData(token);
	};

	const loadSeasonListData = (token : string) => {
		fetch(getWlcServiceLocationBase() + '/seasons', {headers: {'Authorization': 'Bearer ' + token} } )
		.then(res => res.json())
		.then((data) => {
			setSeasonList(data);
		})
		.catch(console.log);
	};

	return (
		<div>
			<center><h1>Season List</h1></center>
			<SeasonsTable title={'Season List'} list={seasonList} />
			<br />
			<ul>
				<li>Click on the link in the <b>Entries</b> column to see the records for that season.</li>
			</ul>
			<Outlet />
		</div>
	);

};

export default SeasonList;

/*async function init() {
  const token = await authenticateNew();
  //alert('jwt: ' + jwt);
  const response = await fetch(getWlcServiceLocationBase() + '/seasons', {headers: {'Authorization': 'Bearer ' + token} } );
  const jsonData = await response.json();
				setSeasonList(jsonData);
  //alert('jsonData: ' + jsonData);
}

	const loadSeasonListDataOld = () => {
		
		function myResolver(n) {
			alert('resolving...' + n)
		}
		
		function myRejecter(n) {
			alert('rejecting...' + n)
		}
		
		function myExecutor(myResolver, myRejecter) {
		  // Typically, some asynchronous operation that accepts a callback,
		  // like the `readFile` function above
		}

		const myPromise = new Promise(myExecutor)
		
		authenticate().then(r => r.json() ).then(j => {
			fetch(getWlcServiceLocationBase() + '/seasons', {headers: {'Authorization': 'Bearer ' + j.token} } )
			.then(res => res.json())
			.then((data) => {
				setSeasonList(data)
			})
			.catch(console.log)
		}).catch(console.log)
	}*/


